import { SevenPTransportAlertFeature } from '../features/alert-transport/alert-transport.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class SevenPTransportAlertLayerRenderer extends StandardLayerRenderer {
  protected Feature = SevenPTransportAlertFeature;
}
